import {ChangeEvent, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import Cookies from 'js-cookie';
import {UserStories, UserStory} from 'src/types/epic';
import Loader from 'src/components/loader';
import {User} from 'src/types/user';
import {Platform} from 'src/types/constants';
import {Modal} from 'src/components';
import {useGetUserstories, useUpdateUserstories} from 'src/queries/userstory';
import {UserStoryItem} from './userStory';
import React from 'react';

export default function ListPage() {
    // const platform: Platform = JSON.parse(Cookies.get('platform') || '{}');
    const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}")
    const user: User = JSON.parse(Cookies.get('user') || '{}');
    const navigate = useNavigate();
    const {data, error, isLoading, refetch, isFetching} = useGetUserstories();
    const [userstories, setUserstories] = useState<UserStory[]>();
    const [selectedUserstory, setSelectedUserstory] = useState<UserStory>();
    const {mutate: assignRequest, data: assignResult} = useUpdateUserstories();
    const [tagList, setTagList] = useState<Set<string>>(new Set())
    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const searchedValue = e.target.value;

        const searchedResult = data?.filter(
            (story) =>
                (story.assigned_to === user.id || !story.assigned_to) && story.subject.toLowerCase().includes(searchedValue),
        );

        setUserstories(searchedResult);
    };

    const handleAssign = async () => {
        const user: User = JSON.parse(Cookies.get('user') || '{}');
        if (!selectedUserstory?.epics[0].id) return;
        await assignRequest({
            id: selectedUserstory.id,
            userId: user.id.toString(),
            version: selectedUserstory?.version,
        });
    };

    const handleConfirmModal = (userstory: UserStory) => {
        if (userstory.assigned_to) {
            console.log('====>', userstory.assigned_to)
            // navigate(`/epics/${userstory.epics[0].id}`);
            // return;
        }
        setSelectedUserstory(userstory);
        const confirmModal = document.querySelector('#confirmModal') as HTMLElement;
        confirmModal.click();
    };

    const handleKeyup = (e: KeyboardEvent) => {
        if (e.key.toLowerCase() === 'escape') {
            const confirmModal = document.querySelector('#confirmModal') as HTMLInputElement;
            confirmModal.checked = false;
        }
    };

    useEffect(() => {
        if (assignResult) {
            navigate(`/epics/${assignResult?.epics[0].id}`);
        }
    }, [assignResult, navigate]);
    useEffect(() => {
        if (data?.length) {
            let filteredUserstories = data.filter((userstory) => userstory.assigned_to === user.id || !userstory.assigned_to);

            filteredUserstories = filteredUserstories.sort((a) => (a.assigned_to ? -1 : 1));
            setUserstories(filteredUserstories);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        if (error) {
            toast(JSON.stringify(error));
        }
    }, [error]);

    useEffect(() => {
        window.addEventListener('keyup', handleKeyup);

        return () => {
            window.removeEventListener('keyup', handleKeyup);
        };
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const checkForActiveCart = () => {
        if (userstories) {
            for (const item of userstories) {
                const isMyTask = item.assigned_to === user.id
                item.tags.map(tag => {
                    if ((tag[0] === 'فورس' || tag[0] === 'فورس2' || tag[0] === 'فورس3') && !isMyTask) {
                        setTagList((prev) => prev.add(tag[0]))
                    }
                })
            }
        }
    }

    useEffect(() => {
        checkForActiveCart()
    }, [checkForActiveCart, userstories])

    function hasElementsInOrder(a: Set<string>, b: Set<string>): boolean {
        let foundPrevious = false;
        for (const item of a.values()) {
            if (!b.has(item)) {
                return false;
            }

            if (foundPrevious && !b.has(item)) {
                return false;
            }

            foundPrevious = true;
        }
        return true;
    }

    const handleClickInCarts = (userstory: UserStory, userStories: UserStories) => {
        const tagNames: Set<string> = new Set(userstory.tags.map(tag => tag[0]))
        const clickable = hasElementsInOrder(tagList, tagNames)
        const isMyTask = userstory.assigned_to === user.id
        if ((clickable || isMyTask) && (userStories[0].id === userstory.id)) {
            handleConfirmModal(userstory)
        } else {
            toast('ابتدا کارت های با اولویت بالاتر یا اولین کارت را انتخاب کنید')
        }
    }


    return (
        <div className="pt-5">
            <div className="flex my-5 justify-between">
                <input
                    className="input w-full max-w-xs input-bordered"
                    placeholder="جستجو..."
                    onChange={handleSearch}
                />
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        setUserstories([]);
                        refetch();
                    }}
                >
                    بارگزاری مجدد لیست
                </button>
            </div>

            <h1 className="title mb-2">صف بازبینی {platform?.name}</h1>
            <ul className="menu bg-base-100 w-full rounded-box">
                {userstories?.map((userstory) => {
                    return (
                        <li
                            key={userstory.id}
                            className={`border-2 ${userstory?.assigned_to_extra_info?.full_name_display ? 'bg-blue-50' : ''}`}
                        >
                            <UserStoryItem
                                userstory={userstory}
                                userstories={userstories}
                                clickHandler={handleClickInCarts}
                            />
                        </li>
                    );
                })}
            </ul>

            <Modal.Assign onClick={handleAssign}/>

            {(isLoading || isFetching) && <Loader/>}
        </div>
    );
}
